import { render, staticRenderFns } from "./RevisingEditor.vue?vue&type=template&id=803a821a&scoped=true"
import script from "./RevisingEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./RevisingEditor.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./RevisingEditor.vue?vue&type=style&index=0&id=803a821a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803a821a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('803a821a')) {
      api.createRecord('803a821a', component.options)
    } else {
      api.reload('803a821a', component.options)
    }
    module.hot.accept("./RevisingEditor.vue?vue&type=template&id=803a821a&scoped=true", function () {
      api.rerender('803a821a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/proofreading/revising/RevisingEditor.vue"
export default component.exports